import React from 'react';
import {
  AiFillFacebook,
  AiFillLinkedin,
  AiOutlineInstagram,
  AiOutlineTwitter,
} from 'react-icons/ai';
import { ContactUs } from './ContactUs';

export const Description = () => {
  return (
    <>
      <div className='px-4 py-12 mx-auto container w-12/12 bg-white '>
        <img src='/separatorHero.svg'  alt='konzortia'/>
        <div className='flex flex-col md:flex-row lg:flex-row '>
          <div className='lg:w-8/12 w-12/12 leading-loose py-12 px-12 flex flex-col content-left justify-left text-left'>
            <span className='font-primary font-size-22 text-black '>
              Konzortia Capital is building the digital backbone of private markets.
              <br/><br/>
              <i>Private capital was designed for insiders. We&apos;re flipping the script by building an intelligent, trusted marketplace.</i> We help investors discover quality deals, founders raise the right capital, and both parties transact with speed, transparency, and built-in liquidity.
              <br/><br/>
              Our platform handles the full deal cycle from sourcing and AI-powered matching to execution and exit all in one platform.
            </span>
            
            <div className='h-full pt-12'>
              <img src='/industryGaps.svg' alt='konzortia' />
            </div>
          </div>
          <div className='py-12 w-12/12 lg:w-4/12'>
            <div className='flex flex-col h-100'>
              <ContactUs />
              
              <div className='w-full px-2 flex center-div'>
                 <iframe
                      src="https://player.vimeo.com/video/1113260116"
                      width="450"
                      height="350"
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowFullScreen
                      title="Vimeo Video"
                    ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
